import React, { memo } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../shadcn/card";
import { Separator } from "../../shadcn/separator";
import { formatNumber } from "../../numberingformat";
import { MapPin, Calendar, Truck, Check, ChefHat } from "lucide-react";

export const OrderDetailsDisplayCard = memo(({ orderData, menuData }) => {
  if (!orderData) return null;
  const currentMenuData = menuData || {};

  return (
    <Card className="w-full overflow-hidden">
      <CardHeader className="space-y-1 bg-merah-hover/5 border-b">
        <CardTitle className="text-merah-hover text-xl w-full">
          {orderData.formattedDate || "N/A"}
        </CardTitle>
        <CardDescription className="flex items-center gap-1 text-neutral-500">
          <MapPin size={14} /> {orderData.customer_name || "N/A"}
        </CardDescription>
      </CardHeader>
      <CardContent className="@container flex flex-col gap-2 pt-6">
        <span className="font-semibold text-sm">Status Pengiriman</span>
        <div className="flex flex-col gap-2 text-xs xs:text-sm">
          <div className="flex items-center justify-between @md:justify-center @md:grid @md:grid-cols-2 gap-4">
            <div className="flex items-center gap-2">
              <Calendar size={14} />{" "}
              <span className="font-medium">Terjadwal</span>
            </div>
            <span>{formatNumber(orderData.qty_sch)} Porsi</span>
          </div>
          <div className="flex items-center justify-between @md:justify-center @md:grid @md:grid-cols-2 gap-4">
            <div className="flex items-center gap-2">
              <Truck size={14} /> <span className="font-medium">Terkirim</span>
            </div>
            <span>{formatNumber(orderData.qty_real)} Porsi</span>
          </div>
          {orderData.hasSubmittedReport && (
            <div className="flex items-center justify-between @md:justify-center @md:grid @md:grid-cols-2 gap-4">
              <div className="flex items-center gap-2">
                <Check size={14} />{" "}
                <span className="font-medium">Diterima</span>
              </div>
              <span>{formatNumber(orderData.received_qty)} Porsi</span>
            </div>
          )}
        </div>
      </CardContent>
      <Separator />
      <CardContent className="flex flex-col gap-6 flex-wrap text-sm py-6">
        <div className="grid grid-cols-1 xs:grid-cols-2 gap-3">
          {Object.entries(currentMenuData).map(
            ([key, value]) =>
              value !== null &&
              value !== "-" && (
                <div key={key} className="flex flex-col gap-0">
                  <span className="font-semibold">{value}</span>
                  <span className="font-light text-sm capitalize text-neutral-500">
                    {key}
                  </span>
                </div>
              ),
          )}
          {Object.values(currentMenuData).every(
            (item) => item === null || item === "-",
          ) && <p>Menu tidak tersedia.</p>}
        </div>
      </CardContent>
      <div className="p-6 border-t flex items-center gap-3 w-full shadow-none bg-neutral-50">
        <div className="rounded-full p-2 bg-card border-neutral-300 border">
          <ChefHat size={16} />
        </div>
        <div className="flex flex-col gap-0">
          <span className="text-sm font-semibold">
            Dapur {orderData.kitchen_name || "N/A"}
          </span>
          <span className="text-neutral-500 text-xs">Penyedia Makanan</span>
        </div>
      </div>
    </Card>
  );
});
